import styled from 'styled-components'

export const MainMenuStyledContainer = styled.div`
    .main-menu.ant-menu-dark, .ant-menu-item {
      background: #373737;
    }

    .ant-menu {
      background: #373737 !important;
    }
  
    .ant-menu-item:hover {
      background: #474747 !important;
    }
  
    .ant-menu-item-selected {
      background: #4e4e4e !important;
    }
`
